var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeArrowImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221,
    height: 56,
    viewBox: "0 0 221 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.52 56H0.00585938L35.3103 28L0.00585938 0H184.52L220.006 28L184.52 56Z",
    fill: "#FFB994",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.243 0.8L218.714 28L184.243 55.2H2.30199L35.8075 28.6268L36.5978 28L35.8075 27.3732L2.30199 0.8H184.243Z",
    stroke: "#FFA26D",
    strokeOpacity: 0.6,
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeArrowImg);
export default __webpack_public_path__ + "static/media/orange-arrow-img.6ace9e42524c74b09b4da904236ac009.svg";
export { ForwardRef as ReactComponent };